import type { FC } from 'react';

import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import cn from 'classnames';

interface ModalBackButtonProps {
  onBack: () => void;
  label: string;
  // Per-layout positioning: absolute corner on desktop panels, header slot on bottom sheets.
  className?: string;
}

// Shared back affordance of the community modals, styled after ModalCloseButton.
export const ModalBackButton: FC<ModalBackButtonProps> = ({ onBack, label, className }) => (
  <button
    type="button"
    onClick={onBack}
    className={cn(
      'group flex items-center justify-center rounded-full transition-colors duration-150 hover:bg-black/5 active:scale-95',
      className,
    )}
    aria-label={label}
  >
    <ArrowLeftIcon
      className="size-6 text-black opacity-50 transition-opacity duration-150 group-hover:opacity-80"
      aria-hidden="true"
    />
  </button>
);
